module.exports = __webpack_public_path__ + "static/media/primary.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brands/png/mhi/primary.png
// module id = 2711
// module chunks = 0